import { formatDistanceStrict } from 'date-fns';
import { NotificationTimeTranslations } from '../../../../../../../../../../../components/blackrock/advisor-center/_types/header.ts';

const getReadableRelativeTime = (
	timestamp: number,
	timeTranslations: NotificationTimeTranslations
) =>
	formatDistanceStrict(timestamp, new Date(), {
		addSuffix: false,
		locale: {
			formatDistance: (token: string, count: number) =>
				`${count}${timeTranslations[`${token.replace('x', '').toLowerCase()}Ago` as keyof NotificationTimeTranslations]}`,
		},
	});

export default getReadableRelativeTime;
